module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門2_2_1.947a56a5.png";